import { c as _c } from "react/compiler-runtime";
import { getNumberRangeFilterId, parseNumberRangeFilterId } from "@components/common/faro-table/faro-table-filter/number-range-filter/number-range-filter-utils";
import { Button, NumberField, Text } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { useState } from "react";

/** The limits of a number range while the user types them, which are null while empty */

/** The fields to type the minimum and the maximum of a number range, shown in the dropdown of its chip */
export function NumberRangeFields(t0) {
  const $ = _c(39);
  const {
    countedName,
    activeRange,
    onCancel,
    onApply
  } = t0;
  const t1 = activeRange?.min ?? null;
  const t2 = activeRange?.max ?? null;
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = {
      min: t1,
      max: t2
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const [input, setInput] = useState(t3);
  let isWhole;
  let range;
  let t4;
  if ($[3] !== input) {
    range = toNumberRange(input);
    let t5;
    if ($[7] !== input.max || $[8] !== input.min) {
      t5 = [input.min, input.max].every(_temp);
      $[7] = input.max;
      $[8] = input.min;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    isWhole = t5;
    t4 = isWhole && range !== undefined && parseNumberRangeFilterId(getNumberRangeFilterId(range)) === undefined;
    $[3] = input;
    $[4] = isWhole;
    $[5] = range;
    $[6] = t4;
  } else {
    isWhole = $[4];
    range = $[5];
    t4 = $[6];
  }
  const isReversed = t4;
  const canApply = isWhole && (range ? !isReversed : activeRange !== undefined);
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      px: 2,
      py: 1,
      gap: 1.5
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = ["min", "max"];
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== countedName || $[13] !== input) {
    t7 = t6.map(limit => <NumberRangeLimitField key={limit} label={limit === "min" ? "Min" : "Max"} countedName={countedName} value={input[limit]} onValueChange={value_0 => setInput({
      ...input,
      [limit]: value_0
    })} />);
    $[12] = countedName;
    $[13] = input;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = isWhole && !isReversed ? "text.secondary" : "error.main";
  let t9;
  if ($[15] !== t8) {
    t9 = {
      color: t8
    };
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== isReversed || $[18] !== isWhole) {
    t10 = getHint(isWhole, isReversed);
    $[17] = isReversed;
    $[18] = isWhole;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== t10 || $[21] !== t9) {
    t11 = <Text variant="bodyS" sx={t9}>{t10}</Text>;
    $[20] = t10;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      justifyContent: "flex-end",
      gap: 1
    };
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== onCancel) {
    t13 = <Button variant="secondary" onClick={onCancel}>Cancel</Button>;
    $[24] = onCancel;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const t14 = !canApply;
  let t15;
  if ($[26] !== onApply || $[27] !== range) {
    t15 = () => onApply(range);
    $[26] = onApply;
    $[27] = range;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  let t16;
  if ($[29] !== t14 || $[30] !== t15) {
    t16 = <Button variant="primary" disabled={t14} onClick={t15}>Apply</Button>;
    $[29] = t14;
    $[30] = t15;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t13 || $[33] !== t16) {
    t17 = <Stack direction="row" sx={t12}>{t13}{t16}</Stack>;
    $[32] = t13;
    $[33] = t16;
    $[34] = t17;
  } else {
    t17 = $[34];
  }
  let t18;
  if ($[35] !== t11 || $[36] !== t17 || $[37] !== t7) {
    t18 = <Stack sx={t5} onKeyDown={_temp2}>{t7}{t11}{t17}</Stack>;
    $[35] = t11;
    $[36] = t17;
    $[37] = t7;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  return t18;
}
function _temp2(event) {
  return event.stopPropagation();
}
function _temp(value) {
  return value === null || Number.isInteger(value);
}
/** A field to type a limit of a number range */
function NumberRangeLimitField(t0) {
  const $ = _c(11);
  const {
    label,
    countedName,
    value,
    onValueChange
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      width: "2.5rem",
      flexShrink: 0
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== label) {
    t3 = <Text variant="bodyM" sx={t2}>{label}</Text>;
    $[2] = label;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = `${label} ${countedName}`;
  let t5;
  if ($[4] !== onValueChange || $[5] !== t4 || $[6] !== value) {
    t5 = <NumberField aria-label={t4} value={value} min={0} fullWidth={true} onValueChanged={onValueChange} />;
    $[4] = onValueChange;
    $[5] = t4;
    $[6] = value;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t3 || $[9] !== t5) {
    t6 = <Stack direction="row" sx={t1}>{t3}{t5}</Stack>;
    $[8] = t3;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}

/** Returns the text below the fields, which tells what is wrong with the typed limits if anything */
function getHint(isWhole, isReversed) {
  if (!isWhole) {
    return "Enter whole numbers.";
  }
  return isReversed ? "The minimum must not be larger than the maximum." : "Numbers include both limits. Leave a field empty for no limit.";
}

/** Returns the range of the typed limits, or undefined if both fields are empty */
function toNumberRange({
  min,
  max
}) {
  if (min === null && max === null) {
    return undefined;
  }
  return {
    min: min ?? undefined,
    max: max ?? undefined
  };
}